import { azureStorageRoutes } from '../routes'

export default (file, containerName, path) => {
    if (file) {
        return new Promise((resolve) => {
            const upload = async () => {
                const imageLoaded = await azureStorageRoutes.uploadImage(file, path, containerName)
                if (imageLoaded) {
                    resolve(imageLoaded)
                }
            }
            upload()
        })
    } else {
        alert('Imágen no se carga o no se reconoce')
    }
}
